import { registerPlugin } from '@wordpress/plugins';
import DataTable from '../components/DataTable';
import AfterOrderItems from '../components/AfterOrderItems';

const LicenseDashboard = () => {
	return (
		<>
            <DataTable />
            <AfterOrderItems />
		</>
	);
};

registerPlugin('easycommerce-license-addon-dashboard', {
	render: LicenseDashboard,
	scope: 'easycommerce-dashboard',
});
